import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import Login from "./authentication/login";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Routes>
        <Route path={"/login"} element={<Login />} />
        <Route path={``} element={<Navigate to={"/auth/login"} replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppViews;
